import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../utils/quiz-parser.js";
import "../../../context/DevToolsContext.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizImage, getStyles } from "./print-common.js";
const CIRCLED_NUMBERS = ["①", "②", "③", "④", "⑤", "⑥", "⑦", "⑧", "⑨", "⑩"];
function MultiChoicePrint({
  quiz,
  number,
  showCorrectAnswers = false,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const subtype = quiz.subtype;
  const sortedAnswers = quiz.random && Array.isArray(quiz.random) && quiz.random.length > 0 ? quiz.random.map((idx) => quiz.choices[idx]).filter(Boolean) : quiz.choices;
  const correctKeys = new Set(
    quiz.choices.filter((c) => c.correct).map((c) => c.key)
  );
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    imageUrl && /* @__PURE__ */ jsx(PrintQuizImage, { src: imageUrl, printScale }),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "w-full px-[40px]",
          subtype === "B" && (compact ? "grid grid-cols-2 gap-[4px]" : "grid grid-cols-2 gap-[12px]"),
          subtype === "C" && "flex items-center justify-between",
          (!subtype || subtype !== "B" && subtype !== "C") && (compact ? "flex flex-col gap-[2px]" : "flex flex-col gap-[12px]")
        ),
        children: sortedAnswers.map((answer, idx) => {
          const isCorrect = correctKeys.has(answer.key);
          const checked = showCorrectAnswers && isCorrect;
          const choiceImageUrl = getImageUrl(answer.image);
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: cn(
                "flex items-center gap-[8px]",
                checked && "font-bold"
              ),
              children: [
                /* @__PURE__ */ jsx("span", { className: cn(
                  compact ? "text-[18px]" : "text-[20px]",
                  "font-light shrink-0",
                  checked ? "text-[#ff9f19]" : "text-black"
                ), children: CIRCLED_NUMBERS[idx] || `${idx + 1}` }),
                choiceImageUrl && /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: choiceImageUrl,
                    alt: `option-${idx + 1}`,
                    className: "max-h-[40px] w-auto object-contain shrink-0"
                  }
                ),
                answer.answer && /* @__PURE__ */ jsx("span", { className: cn(
                  compact ? "text-[15px] tracking-[-0.09px]" : "text-[16px] tracking-[-0.096px]",
                  "leading-[30px]",
                  checked ? "text-[#ff9f19]" : "text-black"
                ), children: /* @__PURE__ */ jsx(KatexText, { text: answer.answer }) })
              ]
            },
            answer.key
          );
        })
      }
    )
  ] });
}
export {
  MultiChoicePrint
};
//# sourceMappingURL=multi-choice-print.js.map
